import { render, staticRenderFns } from "./vcoach.vue?vue&type=template&id=3c781dcf&lang=pug"
import script from "./vcoach.vue?vue&type=script&lang=ts"
export * from "./vcoach.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports